import {
    Box,
    Button,
    Checkbox,
    FormControl,
    FormControlLabel,
    Radio,
    RadioGroup,
    Stack,
    Typography,
} from '@mui/material'
import React, { useState } from 'react'
import { IvaEnum, useProduct } from '../../context/product_context'
import GenericModal from '../GenericModal'
import { FileList } from '../FileList'
import { FileSelection } from '../FileSelection'
import { getFileEndpoint } from '../../services/media'

export const Step3 = () => {
    const { productInfo, setProductInfo } = useProduct()

    return <></>
}
